import { call, delay, put, select } from "redux-saga/effects";
import axios from "axios";
import {
  AddChargingProfileData,
  AddNewChargePointData,
  AddOCPPTagData,
  ChargingStationMapListView,
  ChargingStationSearchKeyword,
  GetChargeBoxDetails,
  GetChargePointDetailsById,
  GetChargingControllerCommand,
  GetChargingProfileDetails,
  GetChargingStationDetails,
  GetChargingStationDetailsById,
  GetChargingSummary,
  GetConnectorData,
  GetOCPPTagDetails,
  GetOcppTagDetailsById,
  GetReservationData,
  GetTransactionBulkData,
  GetTransactionData,
  GetTransactionMeterValues,
  GetchargingProfileDetailsById,
  GetschedulePerioddetailsbyprofileId,
  OCPPTagSearch,
  StoreNewChargingStationDetails,
  StorePaymentHistory,
  StoreScheduledPeriodDetails,
  UpdateChargePointDataById,
  UpdateChargingProfileDetailsById,
  UpdateChargingStationDetailsById,
  UpdateOcppTagDataById,
  UpdatePaymentConfigurationDetailsById,
  UpdateSchedulePeriodData,
} from "../../actions/chargingstation/index";
import { getToken } from "../../authentication";
import { message } from "antd";

export const chargingStationBaseUrl =
  // "http://chargingstation-node-2-env-1.eba-cmumfwqr.us-east-1.elasticbeanstalk.com:8080/command-center-services/v1/api";
  // "https://9ywy82semc.execute-api.us-east-1.amazonaws.com/command-center-services/v1/api"
  "https://pj19534xx7.execute-api.us-east-1.amazonaws.com/command-center-services";

export const baseUrl =
  "http://ev-charging-station-env.eba-yxcgi27v.us-east-1.elasticbeanstalk.com:8080/command-center-services/v1/api";

export function* getChargingStationDetails(params: any) {
  try {
    let { data } = yield call(getChargingStatinDetailsApi, params);
    yield put({
      type: "STORE_CHARGING_STATION_DETAILS",
      payload: data,
    });
  } catch (err) {
    console.error("Unable to fetch charging Station Details", err);
  }
}

export function* getPaymentConfigurationDetails(params: any) {
  try {
    let { data } = yield call(getPaymentConfigurationDetailsApi, params);
    yield put({
      type: "STORE_PAYMENT_CONFIGURATION_DETAILS",
      payload: data,
    });
  } catch (err) {
    console.error("Unable to fetch charging Station Details", err);
  }
}

export function* addRate(params: any) {
  try {
    let { data } = yield call(addRateDetailsApi, params);
    yield put({
      type: "STORE_RATE_DETAILS",
      payload: data,
    });
  } catch (err) {
    console.error("Unable to fetch charging Station Details", err);
  }
}
export function* getMapViewStatus(params: any) {
  try {
    yield put({
      type: "STORE_TOGGLE__MAP_LIST_VIEW",
      payload: params.payload,
    });
  } catch (err) {
    console.error("Error in Saga", err);
  }
}

export function* getChargingStationDetailsBySearchName(params: {
  type: string;
  payload: { keyword?: string; orgId?: string };
}) {
  try {
    const searchTerm = params.payload?.keyword?.trim() || "";
    const orgId = params.payload?.orgId;
    if (!searchTerm) {
      return;
    }
    const { data } = yield call(getChargingStationsListByNameFromApi, {
      payload: { keyword: searchTerm, orgId },
    });
    yield put({
      type: "STORE_CHARGING_STATION_SEARCH_KEYWORD",
      payload: data,
    });
  } catch (err) {
    console.error("Unable to fetch charging station details:", err);
  }
}

export function* AddNewStation(params: StoreNewChargingStationDetails) {
  try {
    let { data } = yield call(addChargingStationApi, params);
  } catch (err) {
    console.error("unable to add Station", err);
  }
}
export function* getChargingStationById(params: GetChargingStationDetailsById) {
  try {
    let { data } = yield call(getChargingDetailsByIdApi, params);
    yield put({
      type: "STORE_CHARGING_DETAILS_BY_ID",
      payload: data,
    });
  } catch (err) {
    console.error("Unable to get data", err);
  }
}

export function* updateChargingDetailsById(
  params: UpdateChargingStationDetailsById
) {
  try {
    let { data } = yield call(updateChargingDetailsByIdApi, params);
    yield put({
      type: "STORE_CHARGING_DETAILS_BY_ID",
      payload: data,
    });
  } catch (err) {
    console.error("Unable to get data", err);
  }
}
export function* GetReservationDetails(params: GetReservationData) {
  try {
    // console.log("API call is in progress");

    let { data } = yield call(getReservationDetailsApi, params);
    yield put({ type: "STORE_RESERVATION_DATA", payload: data });
  } catch (err) {
    console.log("unable to get Data", err);
  }
}

export function* GetTransactionDetails(params: GetTransactionData) {
  try {
    let { data } = yield call(getTransactionDetailsApi, params);
    // yield delay(60000);
    yield put({
      type: "STORE_TRANSACTION_DATA",
      payload: data,
    });
  } catch (err) {
    console.log("unable to get Data", err);
  }
}
export function* GetTransactionBulkDetails(params: GetTransactionBulkData) {
  try {
    let { data } = yield call(getTransactionBulkDetailsApi, params);
    // yield delay(60000);
    yield put({
      type: "STORE_TRANSACTION_DATA",
      payload: data,
    });
  } catch (err) {
    console.log("unable to get Data", err);
  }
}

export function* pollTransactionDetails(params: GetTransactionData) {
  while (true) {
    yield call(GetTransactionDetails, params);
  }
}
export function* getOCPPTagData(params: GetOCPPTagDetails) {
  try {
    let { data } = yield call(getOCPPTagDataApi, params);
    yield put({
      type: "STORE_OCPP_TAG_DETAILS",
      payload: data,
    });
  } catch (err) {
    console.log("unable to get Data", err);
  }
}
export function* getTransactionMeterValuesByID(params: any) {
  try {
    let { data } = yield call(getTransactionByIDApi, params);
    yield put({
      type: "STORE_TRANSACTION_METER_VALUES",
      payload: data,
    });
  } catch (err) {

    console.error("Unable to get data", err);
  }
}
export function* getOCPPTagSearchData(params: OCPPTagSearch) {
  try {
    let { data } = yield call(getOCPPTagSearchByTagId, params);
    yield put({
      type: "STORE_OCPP_TAG_DETAILS",
      payload: data,
    });
  } catch (err) {
    console.log("unable to get Data", err);
  }
}
export function* addnewOcppTagData(params: AddOCPPTagData) {
  try {
    let { data } = yield call(addNewOcppTagDataApi, params);
  } catch (err) {
    console.error("Error", err);
  }
}

export function* getOcppTagDatabyId(params: GetOcppTagDetailsById) {
  try {
    let { data } = yield call(getOCPPTagDataByIdApi, params);
    yield put({ type: "STORE_OCPP_TAG_DETAILS_BY_ID", payload: data });
  } catch (err) {
    console.error("Error", err);
  }
}

export function* updateOcppDetailsById(params: UpdateOcppTagDataById) {
  try {
    let { data } = yield call(updateOcppDetailsByIdApi, params);
    yield put({ type: "STORE_OCPP_TAG_DETAILS_BY_ID", payload: data });
  } catch (err) {
    console.error("Unable to get data", err);
  }
}

export function* updatePaymentConfigurationDetailsById(params: UpdatePaymentConfigurationDetailsById) {
  try {
    let { data } = yield call(updatePaymentConfigurationDetailsByIdApi, params);
    yield put({ type: "STORE_PAYMENT_CONFIGURATION_DETAILS_BY_ID", payload: data });
  } catch (err) {
    console.error("Unable to get data", err);
  }
}


export function* getChargingProfileData(params: GetChargingProfileDetails) {
  try {
    let { data } = yield call(getChargingProfileDataApi, params);
    yield put({ type: "STORE_CHARGING_PROFILE_DETAILS", payload: data });
  } catch (err) {
    console.error("Error", err);
  }
}

export function* addNewChargingProfileData(params: AddChargingProfileData) {
  try {
    let { data } = yield call(addNewChargingProfileDataApi, params);
  } catch (err) {
    console.error("Error", err);
  }
}

export function* getchargingProfileDataById(
  params: GetchargingProfileDetailsById
) {
  try {
    let { data } = yield call(getchargingProfileDataByIdApi, params);
    yield put({ type: "STORE_CHARGING_PROFILE_DETAILS_BY_ID", payload: data });
  } catch (err) {
    console.error("Unable to get data", err);
  }
}
export function* updatechargeProfileDataById(
  params: UpdateChargingProfileDetailsById
) {
  try {
    let { data } = yield call(updatechargeProfileDataByIdAPi, params);
    yield put({ type: "STORE_CHARGING_PROFILE_DETAILS_BY_ID", payload: data });
  } catch (err) {
    console.error("Unable to get data", err);
  }
}
export function* storeConnectorDetails(params: GetConnectorData) {
  try {
    let { data } = yield call(getConnectorDetailsApi, params);
    yield put({ type: "STORE_CONNECTOR_DETAILS", payload: data });
  } catch (err) {
    console.error("Error", err);
  }
}
export function* getChargeBoxDetails(params: GetChargeBoxDetails) {
  try {
    let { data } = yield call(getChargeBoxApi, params);
    yield put({ type: "STORE_CHARGE_POINT_DETAILS", payload: data });
  } catch (err) {
    console.error("error", err);
  }
}
export function* addNewChargeBoxDetails(params: AddNewChargePointData) {
  try {
    let { data } = yield call(addChargeBoxApi, params);
  } catch (err) {
    console.error("Error", err);
  }
}

export function* getchargePointDataById(params: GetChargePointDetailsById) {
  try {
    let { data } = yield call(getchargePointDataByIdApi, params);
    yield put({ type: "STORE_CHARGE_POINT_DETAILS", payload: data });
  } catch (err) {
    console.error("Error", err);
  }
}

export function* updateChargeboxDataById(params: UpdateChargePointDataById) {
  try {
    let { data } = yield call(updateChargePointDetailsByIDApi, params);
    yield put({ type: "STORE_CHARGE_POINT_DETAILS", payload: data });
  } catch (err) {
    console.error("Error", err);
  }
}
export function* storeChargingSummaryDetails(params: GetChargingSummary) {
  try {
    let { data } = yield call(getchargingSummaryApi, params);
    yield put({ type: "STORE_CHARGING_SUMMARY_DETAILS", payload: data.data });
  } catch (err) {
    console.error("Error", err);
  }
}
export function* getchargingschedulebyprofileId(
  params: GetschedulePerioddetailsbyprofileId
) {
  try {
    let { data } = yield call(getscheduleperiodbyprofileIdApi, params);
    yield put({
      type: "STORE_SCHEDULE_PERIOD_DETAILS_BY_PROFILE_ID",
      payload: data,
    });
  } catch (err) {
    console.error("Error", err);
  }
}
export function* addNewChargingSchedule(params: StoreScheduledPeriodDetails) {
  try {
    let { data } = yield call(addNewChargingscheduleApi, params);
  } catch (err) {
    console.error("error", err);
  }
}
export function* updateSchedulePeriodData(params: UpdateSchedulePeriodData) {
  try {
    let { data } = yield call(updateSchedulePeriodDetailsApi, params);
    yield put({
      type: "STORE_SCHEDULE_PERIOD_DETAILS_BY_PROFILE_ID",
      payload: data,
    });
  } catch (err) {
    console.error("Error", err);
  }
}
export function* getChargeControllerCommandData(
  params: GetChargingControllerCommand
) {
  try {
    let { data } = yield call(getchargingControllerSetailsApi, params);
    yield put({ type: "STORE_CHARGING_CONTROLLER_COMMANDS", payload: data });
  } catch (err) {
    console.error("Error", err);
  }
}
// API Call
export async function getChargingStatinDetailsApi(params: any) {
  const orgId = params.payload;

  const tokenRes = await getToken();
  const response = await axios.get(
    `${chargingStationBaseUrl}/v1/api/charge-stations/by-orgId/${orgId}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}

export async function getPaymentConfigurationDetailsApi(params: any) {
  const orgId = params.payload;

  const tokenRes = await getToken();
  const response = await axios.post(
    process.env.REACT_APP_WEBAPPAPI + "/getAllPaymentDetails",
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
    {
      data: {
        platForm: "Web",
        orgId: params.payload.orgId
      },
    }
  );
  return response.data;
}

export async function addRateDetailsApi(params: any) {
  const orgId = params.payload;

  const tokenRes = await getToken();
  const response = await axios.post(
    process.env.REACT_APP_WEBAPPAPI + "/savePaymentDetails",

    {

      chargeboxId: params.payload.chargeboxId,
      location: params.payload.location,
      stationName: params.payload.stationName,
      chargeCost: params.payload.chargeCost,
      platForm: params.payload.platForm,
      orgId: params.payload.orgId

    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },

  );
  if (response.data.status === "FAILED") {
    message.warn("Payment configuration already exists for selected chargebox")
  }
  return response.data;
}

export async function addChargingStationApi(values: any) {
  const tokenRes = await getToken();
  const response = await axios.post(
    `${chargingStationBaseUrl}/v1/api/charge-stations`,
    // "https://pj19534xx7.execute-api.us-east-1.amazonaws.com/command-center-services/v1/api/charge-stations",
    values,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}

export async function getChargingDetailsByIdApi(
  params: GetChargingStationDetailsById
) {
  const tokenRes = await getToken();
  const chargeStationId = params.payload;
  const response = await axios.get(
    `${chargingStationBaseUrl}/v1/api/charge-stations/${chargeStationId}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function updateChargingDetailsByIdApi(
  params: UpdateChargingStationDetailsById
) {
  const { id, data } = params.payload;
  const tokenRes = await getToken();
  const response = await axios.put(
    `${chargingStationBaseUrl}/v1/api/charge-stations/${id}`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function getReservationDetailsApi(params: GetReservationData) {
  const orgId = params.payload;
  const tokenRes = await getToken();
  const response = await axios.get(
    `${chargingStationBaseUrl}/v1/api/organizations/${orgId}/reservations`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function getTransactionDetailsApi(params: GetTransactionData) {
  const orgId = params.payload;
  const tokenRes = await getToken();
  const response = await axios.post(
    // `${chargingStationBaseUrl}/v1/api/organizations/${orgId}/transactions`,
    "https://pj19534xx7.execute-api.us-east-1.amazonaws.com/command-center-services/v1/api/transactionsByDateTime",
    // params.payload,
    {
      orgId: params.payload.orgId,
      customerId: params.payload.customerId,
      startTime: params.payload.startTime,
      stopTime: params.payload.stopTime,
      timeZone: params.payload.timeZone,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function getTransactionBulkDetailsApi(
  params: GetTransactionBulkData
) {
  const orgId = params.payload.orgId;
  const browserTimeZone = params.payload.browserTimeZone;
  const tokenRes = await getToken();
  const response = await axios.get(
    `${chargingStationBaseUrl}/v1/api/organizations/${orgId}/transactions?timeZone=${browserTimeZone}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function getOCPPTagDataApi(params: GetOCPPTagDetails) {
  const orgId = params.payload;
  const tokenRes = await getToken();
  const response = await axios.get(
    `${chargingStationBaseUrl}/v1/api/ocpp-tags/by-orgId/${orgId}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}

export async function addNewOcppTagDataApi(values: any) {
  const tokenRes = await getToken();
  const response = await axios.post(
    `${chargingStationBaseUrl}/v1/api/ocpp-tags`,
    values,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function getOCPPTagDataByIdApi(params: GetOcppTagDetailsById) {
  const ocppTagUuid = params.payload;
  const tokenRes = await getToken();
  const response = await axios.get(
    `${chargingStationBaseUrl}/v1/api/ocpp-tags/${ocppTagUuid}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function updateOcppDetailsByIdApi(params: UpdateOcppTagDataById) {
  const { id, data } = params.payload;
  const tokenRes = await getToken();
  const response = await axios.put(
    `${chargingStationBaseUrl}/v1/api/ocpp-tags/${id}`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}

export async function updatePaymentConfigurationDetailsByIdApi(params: UpdatePaymentConfigurationDetailsById) {

  const tokenRes = await getToken();
  const response = await axios.post(
    process.env.REACT_APP_WEBAPPAPI + "/updateChargeCost",
    {
      chargeboxId: params.payload.chargeboxId,
      chargeCost: params.payload.chargeCost,
      platForm: "Web",
      orgId: params.payload.orgId

    },
    {
      headers: {
        // "Content-Type": "application/json",
        // Authorization: tokenRes.token,

      },
    }
  );
  return response.data;
}
export async function getOCPPTagSearchByTagId(params: OCPPTagSearch) {

  const tagId = params.payload;
  const tokenRes = await getToken();
  const response = await axios.get(
    `${chargingStationBaseUrl}/v1/api/ocpp-tags/by-tagId/${tagId}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function getChargingProfileDataApi(
  params: GetChargingProfileDetails
) {
  const tokenRes = await getToken();
  const response = await axios.get(
    `${chargingStationBaseUrl}/v1/api/charging-profiles`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function addNewChargingProfileDataApi(values: any) {
  const tokenRes = await getToken();
  try {
    const response = await axios.post(
      `${chargingStationBaseUrl}/v1/api/charging-profiles`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: tokenRes.token,
          "X-source": "Web",
          "X-vendor": "OCPP",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error; // rethrow the error to propagate it up the call stack
  }
}
export async function getchargingProfileDataByIdApi(
  params: GetchargingProfileDetailsById
) {
  const chargingProfilePk = params.payload;
  const tokenRes = await getToken();
  const response = await axios.get(
    `${chargingStationBaseUrl}/v1/api/charging-profiles/${chargingProfilePk}`,

    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function updatechargeProfileDataByIdAPi(
  params: UpdateChargingProfileDetailsById
) {
  const { id, data } = params.payload;

  try {
    const tokenRes = await getToken();
    const response = await axios.put(
      `${chargingStationBaseUrl}/v1/api/charging-profiles/${id}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: tokenRes.token,
          "X-source": "Web",
          "X-vendor": "OCPP",
        },
      }
    );

    return response.data;
  } catch (error) {

    throw error; // Re-throw the error for the calling code to handle if needed
  }
}

export async function getscheduleperiodbyprofileIdApi(
  params: GetschedulePerioddetailsbyprofileId
) {
  const chargingProfileId = params.payload;
  const tokenRes = await getToken();
  try {
    const response = await axios.get(
      `${chargingStationBaseUrl}/v1/api/charging-profiles/${chargingProfileId}/charging-schedules`,
      // "/v1/api/charging-profiles/{chargingProfileId}/charging-schedules",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: tokenRes.token,
          "X-source": "Web",
          "X-vendor": "OCPP",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error; // Re-throw the error to propagate it to the calling code
  }
}

export async function addNewChargingscheduleApi(values: any) {
  const tokenRes = await getToken();
  try {
    const response = await axios.post(
      `${chargingStationBaseUrl}/v1/api/charging-schedules`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: tokenRes.token,
          "X-source": "Web",
          "X-vendor": "OCPP",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error; // Re-throw the error to propagate it to the calling code
  }
}

export async function updateSchedulePeriodDetailsApi(
  params: UpdateSchedulePeriodData
) {
  const { id, data } = params.payload;
  const tokenRes = await getToken();
  const response = await axios.put(
    `${chargingStationBaseUrl}/v1/api/charging-schedules`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}

export async function getChargeBoxApi(params: GetChargeBoxDetails) {
  const tokenRes = await getToken();
  const response = await axios.get(
    // `${chargingStationBaseUrl}/v1/api/charge-boxes`,
    "https://pj19534xx7.execute-api.us-east-1.amazonaws.com/command-center-services/v1/api/charge-boxes",
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function addChargeBoxApi(values: any) {
  const tokenRes = await getToken();
  const response = await axios.post(
    // `${chargingStationBaseUrl}/v1/api/charge-box`,
    "https://pj19534xx7.execute-api.us-east-1.amazonaws.com/command-center-services/v1/api/charge-boxes",
    values,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function getchargePointDataByIdApi(
  params: GetChargePointDetailsById
) {

  const chargeBoxPk = params.payload;
  const tokenRes = await getToken();
  const response = await axios.get(
    `${chargingStationBaseUrl}/v1/api/charge-boxes/${chargeBoxPk}`,

    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}

export async function updateChargePointDetailsByIDApi(
  params: UpdateChargePointDataById
) {
  const { id, data } = params.payload;
  const tokenRes = await getToken();
  const response = await axios.put(
    `${chargingStationBaseUrl}/v1/api/charge-boxes/${id}`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );

  return response.data;
}
export async function getConnectorDetailsApi(params: GetConnectorData) {
  const tokenRes = await getToken();
  const response = await axios.get(
    `${chargingStationBaseUrl}/v1/api/connectors`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function getchargingSummaryApi(params: GetChargingSummary) {
  const tokenRes = await getToken();
  const response = await axios.get(
    `${chargingStationBaseUrl}/v1/api/charge-stations/count-summary/${params.payload.orgId}`,
    {
      headers: {
        Authorization: tokenRes.token!,
        "Content-Type": "application/json",
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response;
}
export async function getchargingControllerSetailsApi(
  params: GetChargingControllerCommand
) {
  const orgId = params.payload.orgId
  const tokenRes = await getToken();
  const response = await axios.get(
    process.env.REACT_APP_WEBAPPAPI + `/getPricingProfile?org_id=${orgId}`,

    {
      headers: {
        Authorization: tokenRes.token!,
        "Content-Type": "application/json",
        // "X-source": "Web",
        // "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function getChargingStationsListByNameFromApi(params: any) {
  const stationName = params.payload.keyword;
  const orgId = params.payload.orgId;
  const tokenRes = await getToken();
  const response = await axios.get(
    chargingStationBaseUrl +
    "/v1/api/charge-stations/by-name/" +
    stationName +
    "?orgId=" +
    orgId,

    {
      headers: {
        Authorization: tokenRes.token!,
        "Content-Type": "application/json",
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}
export async function getTransactionByIDApi(params: any) {
  const tokenRes = await getToken();
  const response = await axios.post(
    chargingStationBaseUrl + "/v1/api/transactionsMeterValues",
    params.payload,
    {
      headers: {
        Authorization: tokenRes.token!,
        "Content-Type": "application/json",
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response;
}

export function* getPaymentHistoryDetails(params: StorePaymentHistory) {
  try {
    let { data } = yield call(getPaymentHistoryDetailsApi, params);
    // yield delay(60000);
    yield put({
      type: "STORE_PAYMENT_HISTORY",
      payload: data,
    });
  } catch (err) {
    console.log("unable to get Data", err);
  }
}

export async function getPaymentHistoryDetailsApi(
  params: StorePaymentHistory
) {
  const orgId = params.payload.orgId;
  const browserTimeZone = params.payload.browserTimeZone;
  const tokenRes = await getToken();
  const response = await axios.get(
    `${chargingStationBaseUrl}/v1/api/transactions-history?orgId=${params.payload.orgId}&ocppTagId=${params.payload.ocppTagId}&page=${params.payload.page}&size=100`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenRes.token,
        "X-source": "Web",
        "X-vendor": "OCPP",
      },
    }
  );
  return response.data;
}

